/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiUserWallCredentialsStreemWallFromJSON, StreemApiUserWallCredentialsStreemWallToJSON, StreemApiUserWallCredentialsTwilioSyncFromJSON, StreemApiUserWallCredentialsTwilioSyncToJSON, } from './';
export function StreemApiUserWallCredentialsFromJSON(json) {
    return StreemApiUserWallCredentialsFromJSONTyped(json, false);
}
export function StreemApiUserWallCredentialsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'twilioSync': !exists(json, 'twilio_sync') ? undefined : StreemApiUserWallCredentialsTwilioSyncFromJSON(json['twilio_sync']),
        'streemWall': !exists(json, 'streem_wall') ? undefined : StreemApiUserWallCredentialsStreemWallFromJSON(json['streem_wall']),
    };
}
export function StreemApiUserWallCredentialsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'twilio_sync': StreemApiUserWallCredentialsTwilioSyncToJSON(value.twilioSync),
        'streem_wall': StreemApiUserWallCredentialsStreemWallToJSON(value.streemWall),
    };
}
//# sourceMappingURL=StreemApiUserWallCredentials.js.map